import "/src/css/style.scss";

import Navigation from "./modules/Navigation.js";
import Carousel from "./modules/Carousel.js";
import FakeLinks from "./modules/FakeLinks.js";
import Filter from "./modules/Filter.js";
import DateSelector from "./modules/DateSelector.js";

import lazySizes from "lazysizes";
import "lazysizes/plugins/respimg/ls.respimg";

// htmx is loaded globally via CDN in templates/_includes/scripts.twig for Sprig usage

/**
 * Accept HMR as per: https://vitejs.dev/guide/api-hmr.html
 */
if (import.meta.hot) {
  import.meta.hot.accept(() => {
    console.log("HMR");
  });
}

class marinehugonnier {
  constructor() {
    this.init();
  }

  init() {
    // Initialize core modules
    new Navigation();
    new FakeLinks();
      
    // Replace no-js class with js
    document.documentElement.classList.remove('no-js');
    document.documentElement.classList.add('js');

    // Initialize carousels
    const carouselModules = document.querySelectorAll(".js-carousel");
    if (carouselModules.length > 0) {
      carouselModules.forEach((carouselModule) => new Carousel(carouselModule));
    }

    // Initialize filter
    const filter = document.querySelector(".js-filter");
    if (filter) {
      new Filter(filter);
    }

    // Initialize date selector
    const dateSelector = document.querySelector(".js-date-selector");
    if (dateSelector) {
      new DateSelector(dateSelector);
    }
  }
}

// Initialize when DOM is ready
(function () {
  // Enable passive touch events for better performance
  document.addEventListener("touchstart", function () {}, { passive: true });
  
  // Initialize the app
  new marinehugonnier();
})();
